import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class MessageModal extends React.Component {
  static defaultProps = {
    layoutClass: '',
    mainClass: '',
    contentClass: '',
    modalCloseButton: true,
    modificator: '',
    title: '',
    message: '',
    visible: false,
  };

  static propTypes = {
    modificator: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    modalCloseButton: PropTypes.bool,
    visible: PropTypes.bool.isRequired,
    hide: PropTypes.func.isRequired,
  };

  componentWillMount() {
    this.root = document.createElement('div');
    document.body.appendChild(this.root);
  }

  componentWillUnmount() {
    document.body.removeChild(this.root);
  }

  render() {
    const {
      modificator, modalCloseButton, visible, title, message,
    } = this.props;

    return ReactDOM.createPortal(
      <div
        className="modal-layout"
        style={{ display: visible ? 'flex' : 'none' }}
        onClick={(e) => {
          if ((e.currentTarget == e.target)) this.props.hide();
        }}
      >
        <div
          className={classNames('modal-main -alert', {
            '-alert--green': modificator === 'ok',
            '-alert--red': modificator === 'error',
          })}
        >
          <div className="modal-content__wrapper">
            <div className="modal-content">
              {title ? <h2 className="modal-title">{title}</h2> : ''}
              <div className="modal__content">{message || 'Текст сообщения'}</div>
            </div>
          </div>
          {modalCloseButton ? (
            <div className="modal-close" onClick={this.props.hide}>
              Закрыть всплывающее окно
            </div>
          ) : (
            ''
          )}
        </div>
      </div>,

      this.root,
    );
  }
}
